import React, { useEffect, useMemo, useState } from 'react';
import { ModalClosed } from '~misc/icons';
import Select from '~components/Form/components/Select';
import useFunilStatus from '~fetchs/useFunilStatus';
import { SelectArrow, formatVolume, formatFullDate } from '../../helpers/TrackMapping';

const Field = ({ label, children }) => (
  <div className="grid grid-cols-2 items-center gap-3">
    <label className="text-sm font-bold text-primaria">{label}</label>
    {children}
  </div>
);

const NewNegotiationModal = ({ isOpen, onClose, grupoProdutoOptions = [], defaultGrupoProduto = '', onSubmit }) => {
  const [grupo, setGrupo] = useState(defaultGrupoProduto);
  const [volume, setVolume] = useState('');
  const [data, setData] = useState('');
  const [statusOption, setStatusOption] = useState(null);

  const { optionFunisStatus } = useFunilStatus({});

  useEffect(() => {
    if (!isOpen) {
      setGrupo(defaultGrupoProduto);
      setVolume('');
      setData('');
      setStatusOption(null);
    }
  }, [isOpen, defaultGrupoProduto]);

  if (!isOpen) return null;

  const options = grupoProdutoOptions.length > 0 ? grupoProdutoOptions : ['CONCRETO', 'CIMENTO', 'BÁSICAS ENSACADO'];

  const handleSubmit = () => {
    onSubmit?.({
      grupo,
      volume,
      data,
      status: statusOption?.label || '',
      funilStatusId: statusOption?.value ?? null,
    });
  };

  const resetAndClose = () => {
    setGrupo(defaultGrupoProduto);
    setVolume('');
    setData('');
    setStatusOption(null);
    onClose?.();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[99999] flex items-center justify-center">
      <div className="bg-white px-8 py-8 rounded-[20px] shadow-lg relative w-[500px]">
        <button
          type="button"
          onClick={resetAndClose}
          className="text-white p-3 rounded-tr-[20px] bg-quinaria absolute top-0 right-0"
        >
          <ModalClosed />
        </button>

        <h3 className="text-center text-primaria font-bold text-xl mb-6">Nova Negociação</h3>

        <div className="mb-4 relative">
          <select
            value={grupo}
            onChange={(e) => setGrupo(e.target.value)}
            className="h-10 px-3 pr-9 rounded-md border w-full text-sm font-semibold text-center"
          >
            <option value="">Selecione o Grupo</option>
            {options.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>

          <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <SelectArrow />
          </span>
        </div>

        <Field label="Volume">
          <input
            value={volume}
            onChange={(e) => setVolume(formatVolume(e.target.value))}
            className="h-12 px-3 border rounded-md w-full"
          />
        </Field>

        <Field label="Data">
          <input
            value={data}
            onChange={(e) => setData(formatFullDate(e.target.value))}
            className="h-12 px-3 border rounded-md w-full"
          />
        </Field>

        <Field label="Status">
          <Select
            options={optionFunisStatus}
            value={statusOption}
            onChange={(opt) => setStatusOption(opt ?? null)}
            placeholder="Selecione"
            name="status"
            spacingControl
            noMargin
          />
        </Field>

        <hr className="my-4 border-gray-200" />

        <div className="flex justify-between gap-3 mt-6">
          <button type="button" onClick={resetAndClose} className="px-6 py-3 rounded bg-quinaria text-white font-bold">
            Cancelar
          </button>

          <button
            type="button"
            onClick={handleSubmit}
            className="px-6 py-3 rounded bg-secundaria text-primaria font-bold"
          >
            Mapear
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewNegotiationModal;
